/** Small "stale" chip shown when a source hasn't updated within the threshold. */
export function StalenessBadge({ stale }: { stale: boolean }) {
  if (!stale) return null;
  return (
    <span className="badge badge--stale" title="Not updated recently">
      stale
    </span>
  );
}
